export default {
  baseUrl: "https://timikeys.up.railway.app"
  // baseUrl: "http://localhost:4000"
}